import { UNSTRICT_WS, UNSTRICT_WS_SUCCESS, UNSTRICT_WS_ERROR} from './actionTypes';

const initialState = {
    errorUnstrictWs: "",
    loadingUnstrictWs: false,
    successUnstrictWs: ""
}

const unstrictWorkstations = (state = initialState, action) => {
    switch (action.type) {
        case UNSTRICT_WS:
            state = {
                ...state,
                loadingUnstrictWs: true
            }
            break;
        case UNSTRICT_WS_SUCCESS:
            state = {
                ...state,
                loadingUnstrictWs: false,
                successUnstrictWs: action.payload.message
            }
            break;
        case UNSTRICT_WS_ERROR:
            state = { ...state, errorUnstrictWs: action.payload, loadingUnstrictWs: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default unstrictWorkstations;